import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlus = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Plus",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Union",
			d: "M8.57609 4.50577C8.57609 4.20918 8.33565 3.96875 8.03906 3.96875C7.74247 3.96875 7.50204 4.20918 7.50204 4.50577V7.54891H4.4589C4.16231 7.54891 3.92188 7.78935 3.92188 8.08594C3.92188 8.38253 4.16231 8.62296 4.4589 8.62296H7.50204V11.6661C7.50204 11.9627 7.74247 12.2031 8.03906 12.2031C8.33565 12.2031 8.57609 11.9627 8.57609 11.6661V8.62296H11.6192C11.9158 8.62296 12.1562 8.38253 12.1562 8.08594C12.1562 7.78935 11.9158 7.54891 11.6192 7.54891H8.57609V4.50577Z",
			fill: "currentColor",
			stroke: "currentColor",
			strokeWidth: .8,
			strokeLinecap: "round"
		})
	})
});
const ForwardRef = forwardRef(SvgPlus);
export default ForwardRef;
